import { ReduceStore } from 'flux/utils';
import { Map, Record } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import isValidJson from '../util/isValidJson';

export const resourceTypes = [
  'database',
  'google sheets',
  'github',
  'salesforce_api_creds',
  'salesforce_api_token',
];

export class Resource extends Record({
  id: null,
  organizationId: null,
  resourceType: null,
  resourceName: null,
  resourceInfo: null,
}) {
  get valid() {
    return (+this.resourceType !== -1 && !!this.resourceInfo &&
      !!this.resourceName && isValidJson(this.resourceInfo));
  }
}

const rawResourceToRecord = rawResource => (
  new Resource({
    id: +rawResource.id,
    organizationId: +rawResource.organization_id,
    resourceType: rawResource.resource_type,
    resourceName: rawResource.resource_name,
    resourceInfo: JSON.stringify(rawResource.resource_info),
  })
);

const transformResourceList = rawResources => (
  new Map(rawResources.map(rawResource => [+rawResource.id, rawResourceToRecord(rawResource)]))
);

class ResourceStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Credentials.NEW_RESOURCE_ADDED:
        return this.getState().set(-1, new Resource({ id: -1, resourceType: -1, resourceInfo: '{}' }));
      case Constants.Credentials.NEW_RESOURCE_REMOVED:
        return this.getState().delete(-1);
      case Constants.Credentials.RESOURCES_RECEIVED:
        return this.getState().merge(transformResourceList(action.resources));
      case Constants.Credentials.RESOURCE_CREATED:
        return this.getState()
                 .set(action.resource.id, rawResourceToRecord(action.resource))
                 .delete(-1);
      case Constants.Credentials.RESOURCE_RECEIVED:
      case Constants.Credentials.RESOURCE_UPDATED:
        return this.getState().set(action.resource.id, rawResourceToRecord(action.resource));
      case Constants.Credentials.RESOURCE_DELETED:
        return this.getState().delete(action.resourceId);
      default:
        return state;
    }
  }

  getByResourceId(resourceId) {
    return this.getState().get(resourceId, null);
  }
}

const instance = new ResourceStore(AppDispatcher);
export default instance;
